import { sessaoFetchLoading } from '@/service/fetch'

export async function listSelect () {
  return sessaoFetchLoading(`base`, `/api/consulta/tipo?all=1`)
}



// WEBPACK FOOTER //
// ./src/api/tipo.js